export default class TaskPriority {
    parse(data) {
        this.id = parseInt(data.id);
        this.color = data.color;
        this.name = data.name;

        return this;
    }
}
